import styled from "@emotion/styled";
import { space, color, layout, flexbox } from "styled-system";

const Nav = styled.div`
  width: 100%;

  ${{
    boxSizing: "border-box",
    minWidth: 0,
  }}
  ${space};
  ${color};
  ${layout};
  ${flexbox};
`;

export default Nav;
